import { call, put } from 'redux-saga/effects'
import { getStaticCountries } from '../apiModules/staticCountries'
import * as staticCountryEntities from '../reducks/staticCountries'

export function* fetchStaticCountryEntitiesSaga() {
  const response = yield call(getStaticCountries)
  yield put(staticCountryEntities.addCollection(response.result))
  return response
}
